import React, { Children, cloneElement } from 'react';

import StackNavigatorView from './StackNavigatorView';

//----------------------------------------------------------------------
// UTILS
//----------------------------------------------------------------------

const filterChildren = (elm) => elm.type === StackNavigatorView;

const enhanceChildren = (element, navigation) =>
  cloneElement(element, {
    ...element.props,
    navigation
  });

const navigationEnhancer = (elements, navigation) => {
  const children = Children.toArray(elements);
  return children.filter(filterChildren).map((elm) => enhanceChildren(elm, navigation));
};

interface StackNavigatorConsumerProps {
  children: React.ReactNode[] | React.ReactNode;
  navigation: unknown;
}

//----------------------------------------------------------------------
// COMPONENT
//----------------------------------------------------------------------

// TODO: Try to remove this extra div element.
const StackNavigatorConsumer = (props: StackNavigatorConsumerProps) => (
  <div>{navigationEnhancer(props.children, props.navigation)}</div>
);

export default StackNavigatorConsumer;
